export const getCartPriceExcludingTaxes = ({
	balance,
	data,
}: {
	balance?: number | null
	data: unknown
}) => {
	if (
		typeof balance !== 'number' ||
		typeof data !== 'object' ||
		data === null ||
		!('vat' in data) ||
		typeof data.vat !== 'number'
	) {
		return
	}

	return Math.abs(balance) - data.vat
}
